import { Court } from "@app/core/court/domain/model/court";
import { Observable } from "rxjs";

export abstract class CourtRepo {
  abstract getCourts(club_id: string, token: string): Observable<Court[]>;
}
